import {
    BASE_ORDER_EXPANSION,
    expand,
    getPurchaseFlowBFFUrl,
} from '../api/constants';
import { CheckoutState } from '../state';

export const ENABLE_CHECKOUT_EXPRESS_PAYPAL_FF =
    'checkout_enable_express_paypal';

export const POST_CHECKOUT_MANDATORY_QUESTIONS_ORGANIZATIONS_EXCLUSIONS_FF =
    'post-checkout-mandatory-questions-organizations-exclusions';

export const GROUP_WAIVER_QUESTIONS = 'checkout_group_waiver_questions';

export const ASK_REQUIRED_NON_WAIVER_QUESTIONS_AFTER_PAYMENT =
    'checkout_ask_required_non_waiver_questions_after_payment';

export const ENABLE_CAPTCHA_V3_ON_CHECKOUT = 'checkout_enable_recaptcha_v3';

export const ENABLE_GOOGLE_PAY_ON_CHECKOUT = 'checkout_enable_google_pay';

export const ENABLE_CHECKOUT_CORE_RESILIENCY_TLZ =
    'checkout_enable_core_resiliency_tlz';

export const CHECKOUT_CREATE_ORDER = 'checkout_create_order';
export const CHECKOUT_ABANDON_ORDER = 'checkout_abandon_order';
export const CHECKOUT_PAYMENTS_BRAINTREE_CLIENT_TOKEN =
    'checkout_payments_braintree_client_token';

export type ResilienceActionParams = {
    [key: string]: any;
};

type ResilienceAction = (
    state: CheckoutState,
) => (params?: ResilienceActionParams) => string;

export const RESILIENCE_TLZ_ACTIONS: Record<string, ResilienceAction> = {
    // NOTE: We are not using the state yet, but we will need it to support branch testing
    [CHECKOUT_CREATE_ORDER]: (_: CheckoutState) => {
        const purchaseFlowBFFUrl = getPurchaseFlowBFFUrl();
        return (_?: ResilienceActionParams) =>
            `${purchaseFlowBFFUrl}api/v1/orders/create?expand=${expand(
                BASE_ORDER_EXPANSION,
            )}`;
    },
    //checkout_get_attendees: (_: CheckoutState) => 'bff_url',
    //checkout_set_attendees: (_: CheckoutState) => 'bff_url',
    [CHECKOUT_ABANDON_ORDER]: (_: CheckoutState) => {
        const purchaseFlowBFFUrl = getPurchaseFlowBFFUrl();
        return (params?: ResilienceActionParams) =>
            `${purchaseFlowBFFUrl}api/v1/orders/${params?.orderId}/abandon`;
    },
    //checkout_get_order: (_: CheckoutState) => 'bff_url',
    //checkout_update_order: (_: CheckoutState) => 'bff_url',
    //checkout_process_order: (_: CheckoutState) => 'bff_url',
    [CHECKOUT_PAYMENTS_BRAINTREE_CLIENT_TOKEN]: (_: CheckoutState) => {
        const purchaseFlowBFFUrl = getPurchaseFlowBFFUrl();
        return (_?: ResilienceActionParams) =>
            `${purchaseFlowBFFUrl}api/v1/payments/braintree/client_token`;
    },
    //checkout_events_order_payments_options: (_: CheckoutState) => 'bff_url',
    //checkout_users_vault_instruments: (_: CheckoutState) => 'bff_url',
    //checkout_orders_email_preferences: (_: CheckoutState) => 'bff_url',
    //checkout_get_events_spec: (_: CheckoutState) => 'bff_url',
    //checkout_events_units_status: (_: CheckoutState) => 'bff_url',
    //checkout_events_tickets_classes_for_sale: (_: CheckoutState) => 'bff_url',
    //checkout_orders_eligibility: (_: CheckoutState) => 'bff_url',
    //checkout_reserved_pick_widget: (_: CheckoutState) => 'bff_url',
};
